import React from "react";
import { Phone, Menu, X } from "lucide-react";
import { LangToggle } from "./LangToggle";

export const useNavLinks = (t) => [
  { href: "/#services", id: "services", label: t.nav.services },
  { href: "/#about", id: "about", label: t.nav.about },
  { href: "/#gallery", id: "gallery", label: t.nav.gallery },
  { href: "/#contact", id: "contact", label: t.nav.contact },
];

export const DesktopNav = ({ navLinks }) => (
  <nav className="hidden lg:flex items-center gap-8">
    {navLinks.map((l) => (
      <a
        key={l.id}
        href={l.href}
        data-testid={`nav-${l.id}`}
        className="font-display font-semibold text-sm text-brand-primary hover:text-brand-accent transition-colors"
      >
        {l.label}
      </a>
    ))}
  </nav>
);

export const HeaderActions = ({ t, lang, setLang, open, onToggle }) => (
  <div className="flex items-center gap-2 md:gap-3">
    <LangToggle lang={lang} setLang={setLang} />
    <a
      href={`tel:${t.phone.tel}`}
      data-testid="header-call-cta"
      className="hidden md:inline-flex items-center gap-2 btn-primary !py-2.5 !px-4 text-sm"
    >
      <Phone className="w-4 h-4" strokeWidth={2.5} />
      <span className="hidden lg:inline">{t.phone.display}</span>
      <span className="lg:hidden">{t.nav.quote}</span>
    </a>
    <button
      onClick={onToggle}
      data-testid="mobile-menu-toggle"
      aria-label="Toggle menu"
      aria-expanded={open}
      className="lg:hidden w-10 h-10 flex items-center justify-center text-brand-primary"
    >
      {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
    </button>
  </div>
);
